import React, {useState, useEffect} from 'react'
import './WorkDetails.scss'
import { motion } from 'framer-motion'
import {AiFillEye, AiFillGithub, AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai'
import { client, urlFor } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
import { useLocation } from 'react-router-dom'
import { Divider, Typography } from '@mui/material'
import { BsDash, BsDashCircleDotted, BsDashSquare } from 'react-icons/bs'

var h = ["android", "kotlin"]
const WorkDetails = (props) => {
  
  const data = useLocation().state
  console.log(data.tags, "ggg")
  return (
    <div>
      <div className="app__main">
        <div className="app__main_sub">
          <div className="app__main_pic">
            <img src={urlFor(data?.imgUrl)} alt={data?.name} height={300} />
          </div>
          <div className="app__main_text">
            <h2 className="title-text" >
              {data?.title}
            </h2>
            <div className='tags-text'>
              {data?.tags?.map((val, key)=>
              (  
                <Typography  key={key} gap={20}><BsDash/> {val}</Typography>
              ))}
            </div>
            
            <p style={{ marginTop: 10 }}>{data.moreDetails}</p>
          </div>
        </div>
      </div>

      <Divider sx={{m:3}}/>

      <div className="app__workdet-portfolio">
        {data.screens?.map((item, index) => (
          <img
            className="app__workdet-item app__flex"
            src={urlFor(item)}
            alt={index}
            height={200}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkDetails